import * as React from 'react';
import { ILanguage, ITranslateProps } from '../../../models/common';
import { translate } from 'react-i18next';
import * as c from 'models/constants';
import { dropdown, IDropdownProps, closeAllDropdowns } from 'helpers/hooks';
import renderIcon from 'helpers/renderIcon';

interface IProps extends ITranslateProps, IDropdownProps {
	className?: string;
	onLanguageChange: (val: any) => void;
	selectedLanguage: number;
	languageDomainValues?: ILanguage[];
}

@dropdown()
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class LanguageDropdown extends React.Component<IProps, any> {
	constructor(props) {
		super(props);
	}

	ref = React.createRef<HTMLDivElement>();

	private changeLanguage(key: number) {
		this.props.onLanguageChange(key);
		closeAllDropdowns();
	}

	public render() {
		const { languageDomainValues, selectedLanguage, open, toggle, t } = this.props;
		let selectedLanguageName = '';
		if (selectedLanguage && languageDomainValues) {
			selectedLanguageName = languageDomainValues.find((v) => v.key === selectedLanguage)?.value || '';
		}
		const languageOptions: ILanguage[] = [];
		let i: number;
		if (this.props.languageDomainValues.length > 0) {
			for (i = 0; i < 4; i++) {
				//remove when CH and RU languages are supported
				if (languageDomainValues[i] && languageDomainValues[i].key && languageDomainValues[i].culture) {
					languageOptions.push(languageDomainValues[i]);
				}
			}
		}
		return (
			<div className={'dropdownHolder languageMenuHolder ' + (this.props.className || '')} ref={this.props.ref1}>
				<figure onClick={toggle} className="iconBtn">
					<span className="muted mobile">{t('BSPortal_Common_Filter_Language')}</span>
					<span className="desktop">{renderIcon('languageSwitcher', 24, 24, 'desktopMenuLanguageIcon')}</span>
					<span className="mobile">{selectedLanguageName}</span>
				</figure>
				<div
					className={'dropdown languageDropdown right ' + (open ? 'open' : 'closed')}
					style={{ display: open ? 'block' : 'none' }}
				>
					<div className="dropdownList">
						<p className="language-title">{t('Navigation_Main_UserMenu_SelectLanguage')}</p>
						{languageOptions.map((opt) => (
							<figure
								key={opt.key}
								onClick={() => this.changeLanguage(opt.key)}
								className={selectedLanguageName === opt.value ? 'active' : ''}
							>
								<span>{opt.value}</span>
							</figure>
						))}
					</div>
				</div>
			</div>
		);
	}
}

export { LanguageDropdown };
